module.exports = __webpack_public_path__ + "static/media/cdu.b1cd4350.png";